import { z } from 'zod';

export const imageFeatureSchema = z.enum(['brand', 'category']);
export type ImageFeatureInput = z.infer<typeof imageFeatureSchema>;
